;(function() {
  'use strict'

  Controller.$inject = ["websiteService", "portalLayoutService"];
  angular.module('app.core').component('portalFooter', {
    controller: Controller,
    templateUrl: 'portal-footer.html',
  })

  /* @ngInject */
  function Controller(websiteService, portalLayoutService) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.layout = portalLayoutService

    function onInit() {
      ctrl.year = moment().get('year')
      ctrl.termsUrl = websiteService.getTermsUrl()
      ctrl.privacyUrl = websiteService.getPrivacyUrl()
    }
  }
})()
